// extracted by mini-css-extract-plugin
export var alternate = "_k-j";
export var black = "_k-6";
export var blue = "_k-f";
export var blueLight = "_k-e";
export var brand = "_k-8";
export var darkMode = "_k-b";
export var error = "_k-a";
export var gray = "_k-5";
export var grayBlue = "_k-d";
export var iconWrapper = "_k-3";
export var inactive = "_k-7";
export var indigo = "_k-g";
export var orange = "_k-i";
export var pink = "_k-h";
export var primary = "_k-0";
export var purple = "_k-9";
export var success = "_k-4";
export var warning = "_k-c";
export var white = "_k-1";
export var whiteSuccess = "_k-2";